<template >
  <base-material-card color="secondary" class="mx-10" icon="mdi-cog-outline">
    <template v-slot:after-heading>
      <div class="display-1 mt-2 font-weight-light">{{$t('admin_panel')}}</div>
    </template>
    <v-layout class="mx-10" row>
      <v-tabs
        v-model="tabs"
        background-color="transparent"
        color="secondary"
        slider-color="secondary"
      >
        <v-tab class="mr-3" v-if="RBAC_contab_EDIT_SETTINGS">
          <v-icon class="mr-2">mdi-file-tree</v-icon>
          {{$t('edit_pdc')}}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_contab_EDIT_SETTINGS">
          <v-icon class="mr-2">mdi-key-outline</v-icon>
          {{$t('edit_causali')}}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_contab_EDIT_SETTINGS">
          <v-icon class="mr-2">mdi-account-key-outline</v-icon>
          {{$t('edit_cdx')}}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_contab_RENUMERATE_CGE">
          <v-icon class="mr-2">mdi-tune-vertical</v-icon>
          {{$t('renumerate_protocol')}}
        </v-tab>
      </v-tabs>
    </v-layout>

    <v-tabs-items v-model="tabs" class="transparent tabs-container">
      <v-tab-item v-if="RBAC_contab_EDIT_SETTINGS">
        <gest-pdc :card="false" />
      </v-tab-item>
      <v-tab-item v-if="RBAC_contab_EDIT_SETTINGS">
        <list-causali />
      </v-tab-item>
      <v-tab-item v-if="RBAC_contab_EDIT_SETTINGS">
        <list-cdx />
      </v-tab-item>
      <v-tab-item v-if="RBAC_contab_RENUMERATE_CGE">
        <rinumera-protocolli />
      </v-tab-item>
    </v-tabs-items>
  </base-material-card>
</template>
<script>
import listCausali from "@/app/contab/listCausali.vue";
import rinumeraProtocolli from "@/app/contab/rinumeraProtocolli.vue";
import listCdx from "@/app/contab/listCdx.vue";
import gestPdc from "@/app/contab/gestPdc.vue";

export default {
  name: "admin-panel",
  components: {
    "list-causali": listCausali,
    "list-cdx": listCdx,
    "gest-pdc": gestPdc,
    "rinumera-protocolli": rinumeraProtocolli
  },
  data() {
    return {
      tabs: 0,
      RBAC_contab_EDIT_SETTINGS: false,
      RBAC_contab_RENUMERATE_CGE: false
    };
  },
  methods: {},
  created() {
    let _ = this;
    _.RBAC_contab_EDIT_SETTINGS = _.checkUserRole("contab", "EDIT_SETTINGS");
    _.RBAC_contab_RENUMERATE_CGE = _.checkUserRole("contab", "RENUMERATE_CGE");
    _.tabs = parseInt(_.$route.query.tab, 10) || 0;
  },
  watch: {
    tabs(value) {
      // mantiene la tab corrente nell'URL per sopravvivere al reload della pagina
      this.$router
        .replace({ query: { ...this.$route.query, tab: value } })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
  }
};
</script>
